const EDITOR_SCROLL_OFFSET = 88

export function scrollElementIntoEditorView(
  element?: HTMLElement | null,
  block: ScrollLogicalPosition = 'start'
) {
  if (!element) return

  if (block === 'center') {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' })
    return
  }

  const scrollContainer = getScrollContainer(element)
  const elementTop = element.getBoundingClientRect().top

  if (scrollContainer === window) {
    window.scrollTo({
      top: elementTop + window.pageYOffset - EDITOR_SCROLL_OFFSET,
      behavior: 'smooth',
    })
    return
  }

  const container = scrollContainer as HTMLElement
  const containerTop = container.getBoundingClientRect().top
  container.scrollTo({
    top: container.scrollTop + elementTop - containerTop - EDITOR_SCROLL_OFFSET,
    behavior: 'smooth',
  })
}

export function scheduleScrollElementIntoEditorView(getElement: () => HTMLElement | null) {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      scrollElementIntoEditorView(getElement())
    })
  })
}

function getScrollContainer(element: HTMLElement): HTMLElement | Window {
  let parent = element.parentElement

  while (parent) {
    const style = window.getComputedStyle(parent)
    const overflowY = style.overflowY
    const canScroll = /(auto|scroll|overlay)/.test(overflowY)

    if (canScroll && parent.scrollHeight > parent.clientHeight) {
      return parent
    }

    parent = parent.parentElement
  }

  return window
}
